import { render, staticRenderFns } from "./VideoPage.vue?vue&type=template&id=aca4f43c&scoped=true&"
import script from "./VideoPage.vue?vue&type=script&lang=js&"
export * from "./VideoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca4f43c",
  null
  
)

export default component.exports